import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { Transaction } from '@root/entities/transaction'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import type { TypeHelper } from '@blade/std-lib'
import type { UserTransactionsListParams } from '@blade/trade-api-client'
import type { WalletId } from '@root/entities/wallet'

interface UserTransactionRequestParams
  extends TypeHelper.OverrideKeys<
    UserTransactionsListParams,
    { network: Network.Network; walletIds: ReadonlyArray<WalletId> | undefined }
  > {}

export const fetchUserTransactionRequestAction = action(
  async (ctx, { network, ...params }: UserTransactionRequestParams) => {
    const {
      tradeApiClient,
      environment: {
        assets: { tokenLogosHost },
      },
    } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userTransactionsList, [
        {
          ...params,
          walletIds: params.walletIds ? [...params.walletIds] : undefined,
          network: Network.toDto(network),
        },
      ]),
    )

    const mappedResult = pipe(
      result,
      Result.map((it) => ({
        ...it,
        data: it.data.map((dto) => Transaction.fromDto(dto, tokenLogosHost)),
      })),
      Result.mapError(ApiError.fallbackToUnknown),
    )

    return mappedResult
  },
  'fetchUserTransactionRequestAction',
)
